import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom'; // Navigation hook import kiya
import Image1 from "../../assets/bulksms.webp"
// --- IMPORT IMAGES HERE ---
// Ensure these files exist in your 'src/assets' folder
import step1Img from "../../assets/createaccount2.png"
import step2Img from "../../assets/preparecontacts.png";
import step3Img from "../../assets/composemessage.png";
import step4Img from "../../assets/createcampaign2.webp";
import step5Img from "../../assets/testsms.png";
// import step6Img from './assets/step6-launch.png';
// import step7Img from './assets/step7-analyze.png';

export const Bulksms = () => {
  // State to track the currently active step (defaults to 0, the first step)
  const [activeStep, setActiveStep] = useState(0);

  // State to handle which FAQ is open
  const [openFaq, setOpenFaq] = useState(null);

  // Navigation logic initialize kiya
  const navigate = useNavigate();

  // Data for the Benefits Section
  const benefits = [
    {
      title: "Seamless API Integration",
      description: "Connect your existing CRM or application to our gateway instantly. Our developer-friendly REST APIs ensure automated workflows without complex coding requirements.",
      icon: (
        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="w-6 h-6">
          <path strokeLinecap="round" strokeLinejoin="round" d="M17.25 6.75 22.5 12l-5.25 5.25m-10.5 0L1.5 12l5.25-5.25m7.5-3-4.5 18" />
        </svg>
      )
    },
    {
      title: "Tier-1 Carrier Routes",
      description: "Bypass congestion with direct operator connections. We prioritize premium routes to ensure your OTPs and critical alerts land in the inbox, not the void.",
      icon: (
        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="w-6 h-6">
          <path strokeLinecap="round" strokeLinejoin="round" d="M8.25 18.75a1.5 1.5 0 0 1-3 0m3 0a1.5 1.5 0 0 0-3 0m3 0h6m-9 0H3.375a1.125 1.125 0 0 1-1.125-1.125V14.25m17.25 4.5a1.5 1.5 0 0 1-3 0m3 0a1.5 1.5 0 0 0-3 0m3 0h1.125c.621 0 1.129-.504 1.09-1.124a17.902 17.902 0 0 0-3.213-9.193 2.056 2.056 0 0 0-1.58-.86H14.25M16.5 18.75h-2.25m0-11.177v-.958c0-.568-.422-1.048-.987-1.106a48.554 48.554 0 0 0-10.026 0 1.106 1.106 0 0 0-.987 1.106v7.635m12-6.677v6.677m0 4.5v-4.5m0 0h-12" />
        </svg>
      )
    },
    {
      title: "Intelligent Scheduling",
      description: "Maximize impact by reaching customers at the perfect moment. Set campaigns to launch automatically based on user time zones or specific behavioral triggers.",
      icon: (
        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="w-6 h-6">
          <path strokeLinecap="round" strokeLinejoin="round" d="M6.75 3v2.25M17.25 3v2.25M3 18.75V7.5a2.25 2.25 0 0 1 2.25-2.25h13.5A2.25 2.25 0 0 1 21 7.5v11.25m-18 0A2.25 2.25 0 0 0 5.25 21h13.5A2.25 2.25 0 0 0 21 18.75m-18 0v-7.5A2.25 2.25 0 0 1 5.25 9h13.5A2.25 2.25 0 0 1 21 11.25v7.5" />
        </svg>
      )
    },
    {
      title: "Regulatory Compliance",
      description: "Navigate global regulations effortlessly. Our platform handles opt-out management (STOP commands) and GDPR compliance to protect your brand reputation.",
      icon: (
        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="w-6 h-6">
          <path strokeLinecap="round" strokeLinejoin="round" d="M9 12.75 11.25 15 15 9.75M21 12c0 1.268-.63 2.39-1.593 3.068a3.745 3.745 0 0 1-1.043 3.296 3.745 3.745 0 0 1-3.296 1.043A3.745 3.745 0 0 1 12 21c-1.268 0-2.39-.63-3.068-1.593a3.746 3.746 0 0 1-3.296-1.043 3.745 3.745 0 0 1-1.043-3.296A3.745 3.745 0 0 1 3 12c0-1.268.63-2.39 1.593-3.068a3.745 3.745 0 0 1 1.043-3.296 3.746 3.746 0 0 1 3.296-1.043A3.746 3.746 0 0 1 12 3c1.268 0 2.39.63 3.068 1.593a3.746 3.746 0 0 1 3.296 1.043 3.746 3.746 0 0 1 1.043 3.296A3.745 3.745 0 0 1 21 12Z" />
        </svg>
      )
    },
    {
      title: "Dynamic ID Sender",
      description: "Enhance brand recognition by displaying your company name instead of a number. Build trust instantly and increase open rates with verified Sender IDs.",
      icon: (
        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="w-6 h-6">
          <path strokeLinecap="round" strokeLinejoin="round" d="M15 9h3.75M15 12h3.75M15 15h3.75M4.5 19.5h15a2.25 2.25 0 0 0 2.25-2.25V6.75A2.25 2.25 0 0 0 19.5 4.5h-15a2.25 2.25 0 0 0-2.25 2.25v10.5A2.25 2.25 0 0 0 4.5 19.5Zm6-10.125a1.875 1.875 0 1 1-3.75 0 1.875 1.875 0 0 1 3.75 0Zm1.294 6.336a6.721 6.721 0 0 1-3.17.789 6.721 6.721 0 0 1-3.168-.789 3.376 3.376 0 0 1 6.338 0Z" />
        </svg>
      )
    },
    {
      title: "Two-Way Communication",
      description: "Turn notifications into conversations. Enable long codes or virtual numbers to receive customer replies, feedback, and confirmations directly in your dashboard.",
      icon: (
        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="w-6 h-6">
          <path strokeLinecap="round" strokeLinejoin="round" d="M7.5 8.25h9m-9 3H12m-9.75 1.51c0 1.6 1.123 2.994 2.707 3.227 1.129.166 2.27.293 3.423.379.35.026.67.21.865.501L12 21l2.755-4.133a1.14 1.14 0 0 1 .865-.501 48.172 48.172 0 0 0 3.423-.379c1.584-.233 2.707-1.626 2.707-3.228V6.741c0-1.602-1.123-2.995-2.707-3.228A48.394 48.394 0 0 0 12 3c-2.392 0-4.744.175-7.043.513C3.373 3.746 2.25 5.14 2.25 6.741v6.018Z" />
        </svg>
      )
    },
    {
      title: "Smart Audience Filtering",
      description: "Stop wasting budget on invalid numbers. Our HLR lookup technology cleans your database in real-time, ensuring you only pay for messages sent to active devices.",
      icon: (
        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="w-6 h-6">
          <path strokeLinecap="round" strokeLinejoin="round" d="M12 3c2.755 0 5.455.232 8.083.678.533.09.917.556.917 1.096v1.044a2.25 2.25 0 0 1-.659 1.591l-5.432 5.432a2.25 2.25 0 0 0-.659 1.591v2.927a2.25 2.25 0 0 1-1.244 2.013L9.75 21v-6.568a2.25 2.25 0 0 0-.659-1.591L3.659 7.409A2.25 2.25 0 0 1 3 5.818V4.774c0-.54.384-1.006.917-1.096A48.32 48.32 0 0 1 12 3Z" />
        </svg>
      )
    },
    {
      title: "Enterprise Scalability",
      description: "From a thousand messages to a billion. Our infrastructure is built to auto-scale during peak traffic, guaranteeing stability during flash sales or emergency alerts.",
      icon: (
        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="w-6 h-6">
          <path strokeLinecap="round" strokeLinejoin="round" d="M3 13.125C3 12.504 3.504 12 4.125 12h2.25c.621 0 1.125.504 1.125 1.125v6.75C7.5 20.496 6.996 21 6.375 21h-2.25A1.125 1.125 0 0 1 3 19.875v-6.75ZM9.75 8.625c0-.621.504-1.125 1.125-1.125h2.25c.621 0 1.125.504 1.125 1.125v11.25c0 .621-.504 1.125-1.125 1.125h-2.25a1.125 1.125 0 0 1-1.125-1.125V8.625ZM16.5 4.125c0-.621.504-1.125 1.125-1.125h2.25C20.496 3 21 3.504 21 4.125v15.75c0 .621-.504 1.125-1.125 1.125h-2.25a1.125 1.125 0 0 1-1.125-1.125V4.125Z" />
        </svg>
      )
    },
  ];

  // Data for the 'How to Start' Section (Images are placeholders)
  // CHANGED: imageSrc now uses the imported variables instead of strings
  const howToSteps = [
    {
      id: 1,
      title: "Create account",
      description: (
        <>
          <p className="mb-4">Sign up for an Eurofox account to access our portal. This allows you to send messages on various channels, including SMS.</p>
          <p className="font-semibold">Tip: If you want to <span className="underline cursor-pointer">send SMS via API</span>, signing up allows you to generate an API key that will be used to authenticate your requests.</p>
        </>
      ),
      imageSrc: step1Img
    },
    {
      id: 2,
      title: "Prepare contacts",
      description: (
        <>
          <p className="mb-4">Upload your customer database via CSV, Excel, or connect directly through our API. We automatically validate numbers to ensure high delivery rates.</p>
          <p>Organize contacts into groups (e.g., "VIP Customers" or "New Leads") for targeted messaging.</p>
        </>
      ),
      imageSrc: step2Img
    },
    {
      id: 3,
      title: "Create campaign",
      description: (
        <>
          <p className="mb-3">
            Once you log in to the platform, navigate to the SMS section to create a one-time campaign.
            Select your Sender ID — this is the name your customers will see when they receive your message.
          </p>

          <p className="mb-3">
            Write a concise and engaging message. Remember that SMS messages are limited to 160 characters, so keep it short and impactful. Consider personalizing the message to increase engagement.
          </p>

          <p className="font-medium">
            Tip: You can also save frequently used messages as templates for faster campaign creation.
          </p>
        </>
      ),

      imageSrc: step3Img
    },
    {
      id: 4,
      title: "Manage Campaign",
      description: (
        <>
          <p className="mb-3">
            Easily manage your campaigns with full operational control. You can pause, resume, or stop active campaigns at any time based on performance or business needs.
          </p>

          <p className="mb-3">
            Plan ahead by scheduling campaigns for future delivery, and track results through detailed delivery reports and campaign performance insights.
          </p>

          <p className="font-medium">
            Tip: Monitor delivery reports regularly to optimize timing and improve engagement rates.
          </p>
        </>
      ),

      imageSrc: step4Img
    },
    {
      id: 5,
      title: "Test",
      description: (
        <>
          <p className="mb-4">Never send without testing. Send a test SMS to your own phone number to verify links, formatting, and placeholders.</p>
          <p>Ensure that opt-out links are working correctly before the full rollout.</p>
        </>
      ),
      imageSrc: step5Img
    },
    {
      id: 6,
      title: "Launch",
      description: (
        <>
          <p className="mb-4">Ready to go? Hit the send button immediately or schedule it for a specific date and time when your audience is most active.</p>
          <p>Our smart delivery engine handles the throttling to prevent network congestion.</p>
        </>
      ),
      // imageSrc: step6Img
    },
    {
      id: 7,
      title: "Analyze",
      description: (
        <>
          <p className="mb-4">Track your success in real-time. Monitor delivery rates, open rates (for links), and bounce rates directly in the dashboard.</p>
          <p>Download detailed reports to optimize your future campaigns for better ROI.</p>
        </>
      ),
      // imageSrc: step7Img
    },
  ];

  // FAQ Data
  const faqs = [
 {
  question: "What is Bulk SMS Service?",
  answer: `Bulk SMS is a service that allows businesses to send messages to many people at the same time using a single platform.
It is commonly used for sending offers, notifications, alerts, reminders, and OTPs. Messages are delivered through telecom operator networks within seconds.`
},

   {
  question: "How do I start sending SMS using Eurofox?",
  answer: (
    <ul className="space-y-2">
      {[
        "Complete your DLT registration",
        "Get your Sender IDs and templates approved on DLT",
        "Log in to the Eurofox portal",
        "Map approved headers and templates under Configuration",
        "Go to Send SMS section",
        "Upload your contacts",
        "Select your approved template and send"
      ].map((point, i) => (
        <li key={i} className="flex items-start gap-2">
          <span className="mt-2 h-2 w-2 rounded-full bg-orange-500"></span>
          <span>{point}</span>
        </li>
      ))}
    </ul>
  )
},

    {
      question: "What types of SMS can I send through Bulk SMS?",

      answer: "You can send Promotional SMS, Transactional SMS, OTP messages, Service/Utility alerts, and marketing campaigns depending on your registered route and compliance approvals."
    },
    {
      question: "How fast are Bulk SMS messages delivered?",

      answer: "Most messages are delivered within seconds. Delivery speed depends on route type, operator network conditions, and destination region."
    },
    {
      question: "Who uses bulk SMS?",
      answer: "Bulk SMS is used in a wide range of industries, including retail, healthcare, logistics, finance, travel, hospitality, and telecommunications, for purposes such as marketing, customer engagement, and notifications."
    },
    {
      question: "What is the price for bulk SMS?",
      answer: "Pricing typically depends on the destination country and the volume of messages sent. Eurofox offers competitive per-message rates and tiered pricing for high-volume users."
    },
    {
      question: "Is Bulk SMS secure for sensitive communications?",
      answer: "Yes. Enterprise SMS platforms use secure routing, encrypted APIs, and compliant infrastructure to ensure message integrity and data protection."
    },
      {
      question: "Do you provide delivery reports?",
      answer: "Yes. Real-time delivery reports and message status tracking are available through the dashboard and API callbacks."
    }
  ];

  return (
    <div className="w-full font-sans">

      {/* Hero Section */}
      <section className="bg-[#EEF2FC] w-full pt-16 md:pt-24 pb-4 md:pb-10 px-6 md:px-12 lg:px-20">
        <div className="max-w-7xl mx-auto flex flex-col md:flex-row items-center justify-between gap-12">
          {/* Left Content */}
          <div className="w-full md:w-1/2 text-left md:mt-1">
            <h1 className="text-4xl md:text-5xl lg:text-5xl font-medium text-slate-900 leading-tight tracking-tight mb-6">
              Connect with millions in seconds using Eurofox Bulk SMS.
            </h1>
            <p className="text-lg md:text-xl text-slate-700 leading-relaxed max-w-lg mb-8">
              Our bulk messaging platform enables instant global reach, delivering communication that is fast, reliable, and secure.
            </p>
            {/* 3 Professional Points */}
            <div className="flex flex-col gap-4 mb-10">
              <div className="flex items-start gap-3">
                <span className="w-2 h-2 mt-1.5 rounded-full bg-[#F46653] flex-shrink-0"></span>
                <p className="text-sm text-gray-800">
                  <span className="font-bold text-gray-900">Advanced features:</span> Personalize, schedule, and analyze your campaigns with ease.
                </p>
              </div>
              <div className="flex items-start gap-3">
                <span className="w-2 h-2 mt-1.5 rounded-full bg-[#F46653] flex-shrink-0"></span>
                <p className="text-sm text-gray-800">
                  <span className="font-bold text-gray-900">Security & Encryption:</span> Enterprise-grade protection for all messaging data.
                </p>
              </div>
              <div className="flex items-start gap-3">
                <span className="w-2 h-2 mt-1.5 rounded-full bg-[#F46653] flex-shrink-0"></span>
                <p className="text-sm text-gray-800">
                  <span className="font-bold text-gray-900">Real-time Analytics:</span> Track delivery and performance instantly for every campaign.
                </p>
              </div>
            </div>
            {/* Buttons Section */}
            <div className="flex flex-wrap items-center gap-4">
              <button
                onClick={() => navigate('/login')} // Join Us logic
                className="group bg-slate-900 text-white px-6 py-3 rounded-lg font-medium transition-all flex items-center gap-2"
              >
                Join Us
                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={2} stroke="currentColor" className="w-4 h-4 group-hover:translate-x-1 transition-transform">
                  <path strokeLinecap="round" strokeLinejoin="round" d="M13.5 4.5L21 12m0 0l-7.5 7.5M21 12H3" />
                </svg>
              </button>
              <button
                onClick={() => navigate('/pricing')} // Pricing logic
                className="group text-black py-3 font-medium transition-all flex items-center gap-2"
              >
                See SMS pricing
                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={2} stroke="currentColor" className="w-4 h-4 group-hover:translate-x-1 transition-transform">
                  <path strokeLinecap="round" strokeLinejoin="round" d="M13.5 4.5L21 12m0 0l-7.5 7.5M21 12H3" />
                </svg>
              </button>
            </div>
          </div>
          {/* Right Content */}
          <div className="w-full md:w-1/2 flex justify-center md:justify-end">
            <img
              src={Image1}
              alt="Eurofox Bulk SMS Platform Interface"
              className="max-w-full h-auto object-contain"
            />
          </div>
        </div>
      </section>

      {/* Benefits Section */}
      <section className="bg-[#EEF2FC] w-full pt-4 md:pt-8 pb-10 px-6 md:px-12 lg:px-20">
        <div className="max-w-7xl mx-auto">
          {/* Section Heading */}
          <div className="mb-16 text-center">
            <h2 className="text-3xl md:text-5xl font-medium text-slate-900 mb-4">
              Main benefits of Bulk SMS
            </h2>
            <p className="text-medium text-slate-600 max-w-2xl mx-auto">
              Drive engagement and efficiency with a platform designed for high-performance communication.
            </p>
          </div>
          {/* Grid Layout */}
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
            {benefits.map((item, index) => (
              <div
                key={index}
                className="bg-[#D0DCF2] hover:bg-white rounded-2xl p-8 flex flex-col justify-between h-full min-h-[260px] transition-transform hover:-translate-y-1 duration-300"
              >
                <div>
                  <h3 className="text-xl font-medium text-gray-900 mb-3">
                    {item.title}
                  </h3>
                  <p className="text-sm leading-relaxed text-gray-800">
                    {item.description}
                  </p>
                </div>
                {/* Icon positioned at bottom */}
                <div className="mt-6 text-slate-900">
                  {item.icon}
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* NEW SECTION: How to Start (Interactive) */}
      <section className="bg-[#EEF2FC] w-full py-16 md:py-24 px-6 md:px-12 lg:px-20">
        {/* CHANGED: Reduced max-w to 5xl to squeeze the container horizontally */}
        <div className="max-w-5xl mx-auto">

          {/* Centered Heading */}
          <div className="mb-10 text-center">
            <h2 className="text-3xl md:text-5xl font-medium text-slate-900">
              How to start sending bulk SMS
            </h2>
            {/* NEW LINE ADDED HERE */}
            <p className="mt-4 text-lg text-slate-600">
              Here is a simple, easy step-by-step process to get started.
            </p>
          </div>

          <div className=" rounded-3xl overflow-hidden flex flex-col lg:flex-row min-h-[550px]">

            <div className="w-full lg:w-1/3 bg-[#D0DCF2] p-5 md:p-6 flex flex-col justify-center">
              <div className="space-y-1">
                {howToSteps.map((step, index) => (
                  <button
                    key={step.id}
                    onClick={() => setActiveStep(index)}
                    // CHANGED: Reduced padding inside buttons and gap
                    className={`w-full text-left px-4 py-3 rounded-xl transition-all duration-200 flex items-center gap-3 ${activeStep === index
                      ? "bg-white shadow-md text-gray-800 font-base "
                      : "text-gray-800 font-base hover:bg-white/40"
                      }`}
                  >
                    {/* CHANGED: Smaller circle for numbers (w-7 h-7) */}
                    <span className={`flex-shrink-0 w-7 h-7 rounded-full flex items-center justify-center text-xs ${activeStep === index ? "bg-slate-900 text-white" : "bg-slate-200 text-slate-500"
                      }`}>
                      {step.id}
                    </span>
                    <span className="text-base font-medium">{step.title}</span>
                  </button>
                ))}
              </div>
            </div>

            <div className="w-full lg:w-2/3 p-6 md:p-8 flex flex-col bg-[#D0DCF2]">

              <div className="mb-6 animate-fadeIn">
                <h3 className="text-2xl font-medium text-slate-900 mb-4">
                  {howToSteps[activeStep].title}
                </h3>
                <div className="text-base text-gray-700 leading-relaxed max-w-xl">
                  {howToSteps[activeStep].description}
                </div>
              </div>
              <div className="w-[90%] bg-slate-100 rounded-2xl overflow-hidden border border-slate-200 shadow-inner flex items-center justify-center h-62">
                <img
                  src={howToSteps[activeStep].imageSrc}
                  alt={`${howToSteps[activeStep].title} interface preview`}
                  className="w-full h-full object-cover md:object-contain hover:scale-105 transition-transform duration-500"
                />
              </div>

            </div>
          </div>

        </div>
      </section>

      {/* 4th SECTION: Frequently Asked Questions */}
      {/* SHIFTED UP: Added -mt-12 and removed border-t */}
      <section className="bg-[#EEF2FC] w-full py-16 md:py-24 px-6 md:px-12 lg:px-20 -mt-12">
        <div className="max-w-7xl mx-auto flex flex-col lg:flex-row items-start justify-between gap-12">
          
          {/* Left Side: Heading with Animated Underline */}
          <div className="w-full lg:w-1/3">
            <div className="relative inline-block group">
              <h2 className="text-4xl md:text-5xl font-medium text-slate-900 leading-tight">
                Frequently <br className="hidden lg:block" /> asked questions
              </h2>
              {/* ANIMATED UNDERLINE */}
              <span className="absolute left-0 bottom-0 w-1/4 h-1 bg-[#F46653] rounded-full transition-all duration-500 group-hover:w-full"></span>
            </div>
          </div>

          {/* Right Side: Professional Accordion Questions */}
          <div className="w-full lg:w-2/3 space-y-3">
            {faqs.map((faq, index) => (
              <div key={index} className="bg-white rounded-2xl overflow-hidden transition-all duration-300 shadow-sm border border-slate-100 hover:border-slate-300">
                <button
                  onClick={() => setOpenFaq(openFaq === index ? null : index)}
                  className="w-full flex items-center justify-between p-5 md:p-6 text-left hover:bg-slate-50 transition-colors"
                >
                  <span className="text-base md:text-lg font-medium text-slate-800 leading-snug">
                    {faq.question}
                  </span>
                  <svg 
                    xmlns="http://www.w3.org/2000/svg" 
                    fill="none" 
                    viewBox="0 0 24 24" 
                    strokeWidth={2} 
                    stroke="currentColor" 
                    className={`w-5 h-5 text-slate-500 transition-transform duration-300 ${openFaq === index ? 'rotate-180' : ''}`}
                  >
                    <path strokeLinecap="round" strokeLinejoin="round" d="m19.5 8.25-7.5 7.5-7.5-7.5" />
                  </svg>
                </button>
                
                <div 
                  className={`overflow-hidden transition-all duration-300 ease-in-out ${
                    openFaq === index ? 'max-h-[300px] opacity-100' : 'max-h-0 opacity-0'
                  }`}
                >
                  <div className="p-6 pt-0 text-slate-600 leading-relaxed border-t border-slate-50">
                    {faq.answer}
                  </div>
                </div>
              </div>
            ))}
          </div>

        </div>
      </section>

    </div>
  );
};
